<template>
	<div class="position-relative speakers">
		<!-- shape Hero -->
		<section class="section-shaped">
			<div class="shape shape-style-1 shape-default shape-skew">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
			<div class="container shape-container d-flex">
				<div class="col px-0">
					<h1 class="text-white">
						Прошедшие спикерские
						<span>&nbsp;</span>
					</h1>

					<card class="border-0 mt-5" shadow body-classes="">
						<div v-for="meeting in meetings" :key="meeting.when">
							<div class="row align-items-center">
								<div class="col-sm-9">
									<h4>
										<span class="text-warning">{{ meeting.speaker }} &nbsp;</span>
										<b>{{ meeting.topic }}</b>
									</h4>
									<p style="margin-top: -5px; line-height: 1.4;" class="text-large">
										<span>
											<b class="text-success">{{ meeting.soberTime }}</b> трезвости,</span
										>
										{{ meeting.speakerOrigin }}
									</p>
									<audio controls v-if="!meeting.isVideo">
										<source :src="'recordings/' + meeting.recording" __type="audio/mpeg" />
									</audio>

									<div v-if="meeting.isVideo">
										<base-button type="info" @click="modals[meeting.recording] = true">
											Смотреть видео
										</base-button>
										<modal
											:show.sync="modals[meeting.recording]"
											:modal-classes="{ 'modal-lg': 1 }"
											:modal-content-classes="{ 'modal-video': 1 }"
										>
											<template slot="header">
												<h5 class="modal-title" id="exampleModalLabel">
													{{ meeting.speaker }} &nbsp; <b>{{ meeting.topic }}</b>
												</h5>
											</template>

											<video controls style="width:100%" v-if="modals[meeting.recording]">
												<source :src="'recordings/' + meeting.recording" type="video/mp4" />
											</video>
											<b class="text-danger" style="display:block; margin: 10px 15px 15px">
												В начале записи только аудио, презентация появляется в ходе выступления спикера.
											</b>

											<template slot="footer">
												<base-button type="primary" @click="modals[meeting.recording] = false" :outline="true">Закрыть</base-button>
											</template>
										</modal>
									</div>

									<div class="mt-2">
										<div class="text-small pull-right d-sm-none" style="padding-top: 2px">
											<a :href="'recordings/' + meeting.recording" target="_blank" class="" download style="vertical-align: text-bottom">
												<span class=""><i class="fa fa-cloud-download mr-2"></i></span>
												<span class="">Скачать</span></a
											>
										</div>
									</div>
								</div>
								<div class="col-sm-3 text-center d-none d-sm-block">
									<a :href="'recordings/' + meeting.recording" target="_blank" class="mt-5 d-inline-block" download>
										<span class=""><i class="fa fa-cloud-download mr-2"></i></span>
										<span class="">Скачать</span></a
									>
								</div>
							</div>
						</div>
					</card>
					<h4 class="my-4" style="font-weight: 500; color: yellow">
						Друзья, этот сайт существует только на добровольные пожертвования.<br />
						<router-link :to="{ name: 'donate' }" style="text-decoration: underline; color: orange">
							<b>Поддержите нас</b>
						</router-link>
						&ndash; возможно, это поможет другим алкоголикам найти дорогу к нам.
					</h4>
					<div class="col-lg-4"></div>
				</div>
			</div>
		</section>
		<!-- 1st Hero Variation -->
	</div>
</template>

<script>
import state from "../state";

export default {
	name: "contact",
	components: {},
	data() {
		const modals = {};
		state.meetings.filter((m) => m.isVideo).forEach((m) => (modals[m.recording] = false));

		return {
			meetings: state.meetings.filter((m) => m.recording),
			modals: modals,
		};
	},
};
</script>

<style lang="scss">
.speakers {
	audio {
		width: 100%;
	}

	.card-body {
		margin: 13px 0;

		@media (min-width: 980px) {
			margin: 13px;
		}

		h4 {
			margin-bottom: 15px;
		}

		> div + div {
			margin-top: 30px;
			border-top: 2px solid rgba(slateblue, 0.3);
			padding-top: 30px;
		}
	}

	.modal-video {
		.modal-header {
			border: none;
		}
		.modal-body {
			padding: 0;
			border: none;
		}
		.modal-footer {
			padding: 0 15px 10px;
			border: none;
		}
	}

	@media (max-width: 600px) {
	}
}
</style>
